
export default [ "MenuService", "$rootScope",function dcSidebarCollapse( MenuService, $rootScope) {

  return {
    restrict: "EA",
    require: "^dc-page-container",
    link: function (scope, elem, attr, ctrl) {
      //console.log("sidbear collapse");
      elem.bind("click", function (e) {
        //console.log("toggle sidebar");
        ctrl.toggleSidebar();
      });
    }
  };

}];



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-navigation/dc-sidebar-collapse.js